import countries, { CountryType } from "@/constants/countries";

export { getCountryByCode };

const getCountryByCode = (code?: string): CountryType | undefined => {
  return countries.find((country) => country.code === code);
};
